// extracted by mini-css-extract-plugin
var _1 = "Header_hideOnSmall__c8C51";
var _2 = "Header_logo__shVBB";
var _3 = "Header_logoIcon__5-f8I";
var _4 = "Header_menuRight__RgdT+";
var _5 = "Header_notification__IkN6+";
var _6 = "Header_title__l+wMf";
var _7 = "Header_wrapper__SXTn0";
export { _1 as "hideOnSmall", _2 as "logo", _3 as "logoIcon", _4 as "menuRight", _5 as "notification", _6 as "title", _7 as "wrapper" }
